var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "social-button-wrapper" },
    [
      _c(
        "div",
        {
          ref: "button",
          staticClass: "social",
          class: _vm.getClassName(),
          on: {
            mouseenter: _vm.onMouseEnter,
            mouseleave: _vm.onMouseLeave,
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onClick.apply(null, arguments)
            },
          },
        },
        [
          _vm.busy
            ? _c("div", { staticClass: "is-loading button" })
            : _c("div", [
                !_vm.active
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("social.follow")))])
                  : _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("social.followed"))),
                    ]),
              ]),
        ]
      ),
      (_vm.withTooltip && _vm.tooltipMessage) || _vm.error
        ? _c(
            "dx-tooltip",
            {
              attrs: { visible: _vm.showTooltip, target: _vm.$refs.button },
              on: {
                "update:visible": function ($event) {
                  _vm.showTooltip = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "social-tooltip",
                  class: _vm.error ? "error" : "",
                },
                [
                  _vm.error
                    ? _c("icon-alert-decagram", { attrs: { title: "" } })
                    : _vm._e(),
                  _c("span", [_vm._v(_vm._s(_vm.tooltipMessage))]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }